import "./WhyChoose.css";
import bgImage from "../../assets/why-bg.jpg";

import {
  FaBolt,
  FaShieldAlt,
  FaBatteryFull,
  FaLaptopCode,
} from "react-icons/fa";

export default function WhyChoose() {
  return (
    <section
      className="why-choose-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="why-overlay">

        <h2 className="why-title">
          Why clients Choose IPR Technologies?
        </h2>

        <p className="why-description">
  At IPR Technologies, we combine 14 years of engineering expertise with
  innovative power system solutions, renewable energy capabilities, and
  advanced engineering software to deliver reliable, standards-compliant
  solutions for utilities and industries.
</p>

        <div className="why-grid">

          <div className="why-item">
            <FaBolt className="why-icon" />
            <h3>Power System Expertise</h3>
          </div>

          <div className="why-item">
            <FaShieldAlt className="why-icon" />
            <h3>Industry Compliance</h3>
          </div>

          <div className="why-item">
            <FaBatteryFull className="why-icon" />
            <h3>Renewable Energy</h3>
          </div>

          <div className="why-item">
            <FaLaptopCode className="why-icon" />
            <h3>Engineering Software</h3>
          </div>

        </div>

      </div>
    </section>
  );
}